<template>
    <div class="news-item" @click="clickCampaign()">
        <div class="news-picture">
            <img :src="campaign.fullImageUrl" class="img-fluid" />
        </div>
        <div class="news-content">
            <div class="news-name">{{campaign.name}}</div>
            <div class="news-time">{{getPublishDate()}}</div>
        </div>
    </div>
</template>
<script>
import Moment from 'moment';
//helper
import Util from '@/helper/Utility.js'
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: 'news-list',
    props: {
        lbl: Object,
        localeCode: Number,
        index: Number,
        campaign: Object
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign,
            trackingService: new TrackingService(this),
            trackingEventCategory: 'newslist_page'
        };
    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            this.trackingService.event(this.trackingEventCategory, 'click_to_newsdetail', null, null);
            
            var path = '/news/' + this.campaign.id;
            this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPublishDate: function () {
            var publishDate = this.campaign.startDate;
            var message = this.lbl.detail.news_time;

            var result = Moment.unix(publishDate).utc();
            var year = Moment.unix(publishDate).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');

            var date = `${day}/${month}/${year}`;
            var time = result.format('HH:mm');
            //var monthString = this.lblDate.month_short[result.format('M') - 1];

            return Util.stringFormat(message, date, time);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.news-item {
    width: 100%;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 8px 8px;

    .news-picture {
        @include baseCampaignImg(66.67%);
        width: 100%;
        border-radius: 4px 4px 0 0;
    }

    .news-content {
        padding: 8px;
    }

    .news-name {
        @extend %ellipsis-2;
        font-size: 1.5rem;
        font-family: $regular;
        line-height: normal;
        color: $a-gray-333333;
        margin-bottom: 12px;
        
    }

    .news-time {
        font-size: 1.25rem;
        font-family: $regular;
        line-height: normal;
        color: $a-gray-A0A0A0;
    }
}
</style>
